var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    fill: "#fff",
    stroke: "#e1e7ee",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 53,
    rx: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 52,
    rx: 16.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm_icons_Communication_Active_call",
    "data-name": "Stockholm icons / Communication / Active call",
    transform: "translate(14 13.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Stockholm_icons_Communication_Active_call_Background_",
    "data-name": "Stockholm icons / Communication / Active call (Background)",
    width: 24,
    height: 24,
    transform: "translate(0 0.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search_16_",
    "data-name": "search(16)",
    transform: "translate(3.002 2.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.108,6.2,3.462,8.6,1.1,8.654A9.283,9.283,0,0,1,1.036,0h0l2.1.385.92,2.087A5.531,5.531,0,0,0,4.108,6.2Z",
    transform: "translate(0 5.005)",
    fill: "#fbbb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M8.9,0a9.277,9.277,0,0,1,.162,1.731,9.285,9.285,0,0,1-.2,1.935A9.265,9.265,0,0,1,5.6,8.958h0L2.953,8.823,2.579,6.487a5.523,5.523,0,0,0,2.376-2.82H0V0H8.9Z",
    transform: "translate(9.471 7.536)",
    fill: "#518ef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M13.964,5.293h0a9.228,9.228,0,0,1-5.8,2.04A9.266,9.266,0,0,1,0,2.458L3,0a5.51,5.51,0,0,0,5.16,3.576,5.479,5.479,0,0,0,2.783-.754Z",
    transform: "translate(1.104 11.201)",
    fill: "#28b446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M14.146,2.133l-3,2.458A5.511,5.511,0,0,0,3.019,7.477L0,5.005H0A9.269,9.269,0,0,1,14.146,2.133Z",
    transform: "translate(1.036)",
    fill: "#f14336"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.a43ba51fcb387f82280c82659aadebdb.svg";
export { ForwardRef as ReactComponent };